import {Routes} from '@angular/router';
import {DashboardComponent} from '@pages/dashboard/dashboard/dashboard.component';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: {
      title: 'Dashboard',
      titleKey: 'menu.dashboard',
      urls: [
      ],
    }
  }
];
